import { render, staticRenderFns } from "./ItemListHomeMusicLayout.vue?vue&type=template&id=2ecca672&scoped=true"
import script from "./ItemListHomeMusicLayout.vue?vue&type=script&lang=js"
export * from "./ItemListHomeMusicLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecca672",
  null
  
)

export default component.exports